module.exports = __webpack_public_path__ + "img/93.300e4b1a.jpg";